import axiosBasic from '@/utils/axiosBisc.js'

//登陆接口
export async function login(data) {
    return axiosBasic({
        url: '/login',
        method: 'post',
        data: data
    })
}

export async function otpLogin(data) {
    return axiosBasic({
        url: '/verifyOtp',
        method: 'post',
        data: data
    })
}

//登陆接口
export async function sendOtp(data) {
    return axiosBasic({
        url: '/sendOtp',
        method: 'post',
        data: data
    })
}

export async function sendForgotPasswordOtp(data) {
    return axiosBasic({
        url: '/forgotPassword/sendOtp',
        method: 'post',
        data: data
    })
}

export async function resetForgotPassword(data) {
    return axiosBasic({
        url: '/forgotPassword/reset',
        method: 'post',
        data: data
    })
}


//重置密码
export async function forceChangePassword(data) {
    return axiosBasic({
        url: '/system/user/forceChangePassword',
        method: 'post',
        data: data
    })
}

//获取用户信息
export async function getUserInfo() {
    return axiosBasic({
        url: '/system/user/profile',
        method: 'get'
    })
}

export async function acknowledgePrivacyConsent(data) {
    return axiosBasic({
        url: '/system/user/privacy-consent',
        method: 'post',
        data: data,
    })
}

//获取用户信息
export async function MFALogin(params) {
    return axiosBasic({
        url: '/auth/msal/callback',
        method: 'get',
        params: params,
    })
}

//MFA登陆接口 传入code
// export async function MFALogin(data) {
//     return axiosBasic({
//         url: '/api/loginFromMfa',
//         method: 'post',
//         data: data
//     })
// }

//退出登陆接口
export async function logout() {
    return axiosBasic({
        url: '/logout',
        method: 'post'
    })
}

//修改密码
export async function updatePwd(data) {
    return axiosBasic({
        url: '/system/user/profile/updatePwd',
        method: 'put',
        data: data,
    })
}

//获取路由信息
export async function getRouters() {
    return axiosBasic({
        url: '/getRouters',
        method: 'get'
    })
}

//participant登录时 检查是否只有一个engagement,多个的话跳到管理页面
export async function getUserModulesByUserId(params) {
    return axiosBasic({
        url: '/boardSight/engagement/getUserModulesByUserId',
        method: 'get',
        params: params,
    })
}


